import { hotArticles } from './site';

export const articleDetail = {
  id: 4,
  title: '电竞圈大地震！知名选手被爆假赛实锤',
  excerpt: '电竞圈再爆猛料，某知名战队核心选手被前队友实名举报参与假赛，涉及金额高达数百万，官方已介入调查...',
  category: '51吃瓜',
  categorySlug: '51chigua',
  author: '电竞观察员',
  date: '2026-07-07',
  views: 312000,
  comments: 12450,
  tags: ['电竞', '假赛', '实锤'],
  content: `
    <p>近日，电竞圈掀起了一场前所未有的风暴。一位不愿透露姓名的前职业选手通过本网实名举报，某LPL顶级战队的核心选手在近两个赛季的多场关键比赛中涉嫌参与假赛。</p>
    
    <h2>举报内容详实，证据链完整</h2>
    
    <p>根据举报人提供的材料，该选手在2025年夏季赛和2026年春季赛期间，至少参与了5场有问题的比赛。举报人声称掌握了包括银行转账记录、聊天截图以及语音录音在内的多项证据。</p>
    
    <p>"我们手中有一份完整的银行流水，显示该选手在特定比赛前后收到了来自境外账户的大额转账，每笔金额从20万到80万不等。"举报人表示，"这些转账时间与疑似假赛的比赛时间高度吻合。"</p>
    
    <h2>涉及的比赛细节曝光</h2>
    
    <p>据分析，涉及的比赛中最为明显的是2025年夏季赛季后赛的一场BO5。该选手在比赛中多次出现"低级失误"，包括关键时刻的走位失误、技能释放时机异常等。多位职业解说在当时的直播中就对这些操作表示了不解。</p>
    
    <p>更令人震惊的是，举报人还透露，该选手并非单独行动，背后可能存在一个涉及多名选手和教练的假赛网络。</p>
    
    <h2>官方回应：已启动调查程序</h2>
    
    <p>事件发酵后，LPL官方于今日凌晨发布声明，表示已注意到相关举报，并已启动正式调查程序。官方声明称："联盟对任何形式的违规行为持零容忍态度，一旦查实将从严处理。"</p>
    
    <p>与此同时，该选手所在的战队也发布公告，宣布该选手将暂时停赛，配合联盟调查。战队经理在接受采访时表示："我们对这些指控感到震惊，将全力配合调查。"</p>
    
    <h2>圈内反应：多人发声表态</h2>
    
    <p>事件曝光后，多位电竞圈知名人士纷纷发声。前世界冠军中单选手在直播中表示："如果属实，这将是对电竞行业最大的伤害。我们希望调查能尽快出结果。"</p>
    
    <p>知名电竞解说也在社交媒体发文："这几年电竞环境越来越好，绝不能让几颗老鼠屎坏了整锅粥。"</p>
    
    <h2>粉丝反应两极分化</h2>
    
    <p>该选手的粉丝群体出现了明显分裂。一部分粉丝表示难以置信，认为这是恶意诽谤；另一部分粉丝则表示失望，称"如果属实就脱粉"。</p>
    
    <p>截至目前，该选手本人尚未对此事做出任何回应，其社交媒体账号已设置为私密状态。</p>
    
    <p>本网将持续关注此事的后续发展，为读者带来第一手消息。</p>
  `,
  relatedArticles: hotArticles.filter(a => a.id !== 4).slice(0, 4),
  faqs: [
    {
      question: '什么是电竞假赛？',
      answer: '电竞假赛是指职业选手或战队在比赛中故意不发挥真实水平，以达到通过博彩获利或其他不正当目的的行为。假赛严重违反了电竞行业的职业道德和竞技精神。',
    },
    {
      question: '假赛通常会受到什么处罚？',
      answer: '根据LPL联盟规定，参与假赛的选手将面临终身禁赛、罚款以及取消所有荣誉等处罚。情节严重者还可能面临法律诉讼。',
    },
    {
      question: '如何判断一场比赛是否涉及假赛？',
      answer: '通常通过分析选手的异常操作、博彩赔率的异常波动、以及相关转账记录等证据来综合判断。联盟有专门的调查团队负责此类案件。',
    },
    {
      question: '举报假赛有哪些渠道？',
      answer: 'LPL联盟设有专门的举报邮箱和热线，举报人可以选择实名或匿名举报。联盟承诺对所有举报严格保密并认真调查。',
    },
  ],
};

export { hotArticles };